import { Card } from "react-bootstrap";

interface Props {
    variant: string;
    children?: React.ReactNode;
    title?: React.ReactNode | string;
    message?: React.ReactNode | string;
    classNames?: string;
}

export function AlertMessage({
    variant,
    children,
    title,
    message,
    classNames,
}: Props) {
    return (
        <Card
            className={
                classNames
                    ? `alert-message variant-${variant} ${classNames}`
                    : `alert-message variant-${variant}`
            }
        >
            <Card.Body className="alert-text">
                {title ? <div className="alert-header">{title}</div> : null}
                {message ? <div className="alert-text">{message}</div> : null}
                {children}
            </Card.Body>
        </Card>
    );
}
